<template>
    <span
        class="total-expected-promotions-counter"
        :class="{ 'total-expected-promotions-counter--exceeded': isExceeded }"
        :title="
            isExceeded
                ? toSentenceCase($t('planning.scenariosViewer.totalExpectedPromotionsExceeded'))
                : null
        "
    >
        <icon
            v-if="isExceeded"
            class="total-expected-promotions-counter__icon"
            icon-name="custom:warning"
            small
        />
        <span>{{ text }}</span>
    </span>
</template>

<script setup>
import { computed } from 'vue';
import i18n from '@/js/vue-i18n';
import { suffixWithColon } from '@/js/utils/string-utils';

const props = defineProps({
    count: {
        type: Number,
        required: true,
    },
    expected: {
        type: Number,
        required: true,
    },
    withColon: {
        type: Boolean,
        default: false,
    },
    short: {
        type: Boolean,
        default: false,
    },
});

const isExceeded = computed(() => props.count > props.expected);

const text = computed(() => {
    if (props.short) return `${props.count}/${props.expected}`;

    const value = i18n.t(
        'planning.scenariosViewer.promotionsOutOfExpected',
        { count: props.count, expected: props.expected },
        props.count
    );
    return props.withColon ? suffixWithColon(value) : value;
});
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.total-expected-promotions-counter {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    line-height: 1;

    &--exceeded {
        color: $promo-error;
        font-weight: 600;
    }

    &__icon {
        display: inline-flex;
        align-items: center;
        // The v-icon size classes set a fixed height that pushes the text off-centre.
        height: auto !important;
        margin-right: 0.3rem;
    }
}
</style>
